import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Tipo', numeric: true, disablePadding: false, label: 'TIPO', show:true, fixed:false, width:250, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
    ];

    const variablesObject = {
        api:'/api/Tipos',
        apiMultiples:'/api/Tipos/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,   
        label:'TIPO',
        nameLocalStorage:'headersTiposAC',
        order:'asc',
        orderBy:'Tipos',
        OptionSearch:'Tipo',
        rowsPerPage:15,
        Ruta:'/Almacen/Tipos',
        sumWidth:410,
        title:'TIPOS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;